
import store from '../../index.js';
import api from '../../../utils/api.js';

export const modules = ({
    store
})

export const state = ({

});


export const mutations = {  

};

export const actions = {
    async acReportIssue({commit}, payload) {
        try {
            const url = `/api/v1/report-issue`;
            const res = await api.post(url, payload);            
            return res.data?.code === 0;
        } catch (error) {
            return false;
        }
    },
};


export const getters = {

};


export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}